import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/warning-orange-icon.svg'


const _hoisted_1 = { class: "tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#231F20] tw-borer tw-border-[0px] tw-border-t tw-border-solid tw-border-[#EEF0F1]" }
const _hoisted_2 = { class: "tw-w-full tw-text-[16px] tw-leading-[130%] tw-font-semibold tw-mb-[5px]" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58] tw-mb-[10px]" }
const _hoisted_4 = { class: "tw-p-[25px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_6 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_7 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-w-full tw-flex" }
const _hoisted_8 = {
  key: 0,
  class: "tw-flex tw-items-center tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-item-center tw-w-[16px] tw-h-[16px] tw-mr-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_10 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_11 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_13 = { class: "input-container expiryDate-container tw-flex tw-ml-[16px] tw-gap-[25px]" }
const _hoisted_14 = { class: "input-container tw-flex-1 xl:tw-flex-row tw-flex-col tw-flex" }
const _hoisted_15 = { class: "tw-flex tw-items-start sm:tw-items-center tw-gap-2 sm:tw-gap-0 sm:tw-flex-row tw-flex-col tw-min-w-full tw-justify-between" }
const _hoisted_16 = { class: "tw-flex tw-items-center tw-flex-row" }

import {
  getComponentUiText,
  IsEmailValidWhileTyping,
  IsSpecialCharEmailValid,
} from "@/utils/utilities";
import { reactive, watch, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { email, helpers, required } from "@vuelidate/validators";
import BaseInput from "../common/form/baseInput.vue";
import DatePickInput from "../common/datePickInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { OPTION_EXPIRY_DATE_VENDOR } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'recipientDetails',
  props: {
  modelValue: {
    type: Object,
    required: true,
  },
  showWarning: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update:isDisabled", "update:modelValue"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const showPrePopulateWarning = ref(props.showWarning);

const formModel = reactive({
  ...props.modelValue,
});
// formModel.expiryDateOption = OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK;

const customExpiryDate = ref(
  formModel.expiryDateOption === OPTION_EXPIRY_DATE_VENDOR.CUSTOM
    ? formModel.expiryDate
    : "",
);



const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  expiryDate: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    isFutureOrToday: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-vendor-dropdown-validation-base-input-expiry-date-1",
        ),
      (value: string) => {
        if (!value) return true;
        return new Date(value) >= new Date();
      },
    ),
  },
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
    if (formModel.expiryDateOption === OPTION_EXPIRY_DATE_VENDOR.CUSTOM) {
      customExpiryDate.value = value.expiryDate;
    }
    if (value.name && value.email && value.expiryDate) {
      emit("update:isDisabled", true);
    } else {
      emit("update:isDisabled", false);
    }
  },
  { deep: true },
);

watch(
  () => props.showWarning,
  (value) => {
    showPrePopulateWarning.value = value;
  },
);

watch(
  () => props.modelValue,
  (value) => {
    Object.assign(formModel, value);
  },
  { deep: true },
);

const isCheckValid = async () => {
  await $v.value.$validate();
  return !$v.value.$error;
};

const handleSelectExpiryOption = (option: string) => {
  formModel.expiryDateOption = option;
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  switch (option) {
    case OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK:
      date.setDate(date.getDate() + 7);
      formModel.expiryDate = date.toISOString();
      customExpiryDate.value = "";
      break;
    case OPTION_EXPIRY_DATE_VENDOR.TWO_WEEKS:
      date.setDate(date.getDate() + 14);
      formModel.expiryDate = date.toISOString();
      customExpiryDate.value = "";
      break;
    case OPTION_EXPIRY_DATE_VENDOR.CUSTOM:
      if (!customExpiryDate.value) {
        formModel.expiryDate = "";
      }
      break;
  }
};

__expose({
  isCheckValid,
});

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { sm: "5" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-vendor-create-new-vendor-assessment-modal-title-recipient-details-1",
              )) + " ", 1),
                _createVNode(ButtonShowDuplicateAssessment, {
                  "id-popover": 'popover-recipient-details',
                  "custom-class": 'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                  class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
                  classes: `!tw-leading-none`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                        "app-vendor-create-new-vendor-assessment-modal-title-recipient-details-1",
                      )), 1),
                        _createVNode(CustomDescriptionContent, {
                          description: 
                      _unref(getComponentUiText)(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-recipient-details-vendor-1',
                      )
                    ,
                          class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                        }, null, 8, ["description"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                "app-vendor-create-new-vendor-assessment-modal-description-recipient-details-1",
              )), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { sm: "7" }, {
            default: _withCtx(() => [
              (showPrePopulateWarning.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                "app-vendor-create-new-vendor-assessment-modal-recipient-details-warning-1",
              )), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(BaseInput, {
        id: "name",
        modelValue: formModel.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.name) = $event)),
        validation: _unref($v).name,
        container: 'tw-w-full ',
        "data-cy-id": "recipient-details-name",
        "class-name": '!tw-items-center !tw-mt-[0px]',
        "is-required": true,
        label: 'Name',
        placeholder: 
          _unref(getComponentUiText)('app-vendor-dropdown-placehoder-base-input-name-1')
        ,
        onBlur: _cache[1] || (_cache[1] = 
          () => {
            _unref($v).name.$validate();
          }
        )
      }, null, 8, ["modelValue", "validation", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(BaseInput, {
        id: "email",
        modelValue: formModel.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.email) = $event)),
        container: 'tw-w-full ',
        "data-cy-id": "recipient-details-email",
        "class-name": '!tw-items-center !tw-mt-[0px]',
        validation: _unref($v).email,
        label: 
          _unref(getComponentUiText)('app-vendor-dropdown-label-base-input-email-1')
        ,
        placeholder: 
          _unref(getComponentUiText)(
            'app-vendor-dropdown-placehoder-base-input-email-1',
          )
        ,
        onBlur: _cache[3] || (_cache[3] = 
          () => {
            _unref($v).email.$validate();
          }
        )
      }, null, 8, ["modelValue", "validation", "label", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(BaseInput, {
        id: "expiryDate",
        modelValue: formModel.expiryDate,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formModel.expiryDate) = $event)),
        container: 'tw-w-full ',
        "class-name": '!tw-items-center !tw-mt-[0px]',
        validation: _unref($v).expiryDate,
        label: 
          _unref(getComponentUiText)(
            'app-vendor-dropdown-lable-base-input-expiry-date-1',
          )
        ,
        "label-tooltip": 
          _unref(getComponentUiText)(
            'app-vendor-dropdown-label-tooltip-base-input-expiry-date-1',
          )
        
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(BaseCheckbox, {
                  text: 
                  _unref(getComponentUiText)(
                    'app-assessment-vendor-option-expiry-date-1week-1',
                  )
                ,
                  class: _normalizeClass('tw-min-w-max'),
                  "data-cy": "expiry-date-option-1-week",
                  "text-style": 'tw-text-[13px] !tw-font-[500] tw-text-[#231F20] tw-whitespace-nowrap',
                  color: "#387DFF",
                  ticked: 
                  formModel.expiryDateOption ===
                  _unref(OPTION_EXPIRY_DATE_VENDOR).ONE_WEEK
                ,
                  disabled: false,
                  onSelected: _cache[4] || (_cache[4] = 
                  () => {
                    handleSelectExpiryOption(
                      _unref(OPTION_EXPIRY_DATE_VENDOR).ONE_WEEK,
                    );
                  }
                ),
                  onUnselected: () => {}
                }, null, 8, ["text", "ticked"]),
                _createVNode(BaseCheckbox, {
                  text: 
                  _unref(getComponentUiText)(
                    'app-assessment-vendor-option-expiry-date-2weeks-1',
                  )
                ,
                  "text-style": 'tw-text-[13px] !tw-font-[500] tw-text-[#231F20] tw-whitespace-nowrap',
                  "data-cy": "expiry-date-option-2-week",
                  color: "#387DFF",
                  ticked: 
                  formModel.expiryDateOption ===
                  _unref(OPTION_EXPIRY_DATE_VENDOR).TWO_WEEKS
                ,
                  disabled: false,
                  onSelected: _cache[5] || (_cache[5] = 
                  () => {
                    handleSelectExpiryOption(
                      _unref(OPTION_EXPIRY_DATE_VENDOR).TWO_WEEKS,
                    );
                  }
                ),
                  onUnselected: () => {}
                }, null, 8, ["text", "ticked"]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(BaseCheckbox, {
                    text: 
                    _unref(getComponentUiText)(
                      'app-assessment-vendor-option-expiry-date-custom-1',
                    )
                  ,
                    "text-style": 'tw-text-[13px] tw-text-[#231F20] !tw-font-[500]',
                    "data-cy": "expiry-date-option-custom",
                    color: "#387DFF",
                    ticked: 
                    formModel.expiryDateOption ===
                    _unref(OPTION_EXPIRY_DATE_VENDOR).CUSTOM
                  ,
                    disabled: false,
                    onSelected: _cache[6] || (_cache[6] = 
                    () => {
                      handleSelectExpiryOption(
                        _unref(OPTION_EXPIRY_DATE_VENDOR).CUSTOM,
                      );
                    }
                  ),
                    onUnselected: () => {}
                  }, null, 8, ["text", "ticked"]),
                  _createVNode(DatePickInput, {
                    modelValue: customExpiryDate.value,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((customExpiryDate).value = $event)),
                      _cache[8] || (_cache[8] = 
                    (value) => (value ? (formModel.expiryDate = value) : '')
                  )
                    ],
                    placeholder: 
                    formModel.expiryDateOption ===
                      _unref(OPTION_EXPIRY_DATE_VENDOR).CUSTOM ||
                    !formModel.expiryDateOption
                      ? _unref(getComponentUiText)(
                          'app-menu-submenu-home-setup-wizard-start-date-title',
                        )
                      : _unref(convertUTCTimeToLocalTime)(formModel.expiryDate ?? '')
                  ,
                    disabled: 
                    formModel.expiryDateOption !==
                    _unref(OPTION_EXPIRY_DATE_VENDOR).CUSTOM
                  ,
                    "class-name": `tw-w-[215px] tw-ml-[9px]`,
                    "data-cy-id": "expiry-date-option-custom-input",
                    focus: true,
                    "custom-input-class": 'tw-flex tw-flex-1',
                    validation: 
                    formModel.expiryDateOption ===
                    _unref(OPTION_EXPIRY_DATE_VENDOR).CUSTOM
                      ? _unref($v).expiryDate
                      : {}
                  
                  }, null, 8, ["modelValue", "placeholder", "disabled", "validation"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "validation", "label", "label-tooltip"])
    ])
  ]))
}
}

})